import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, selectUserEmail, setUser } from '../Auth/authSlice';
import logo from '../../static/img/logo.jpg';
import './Navigation.css'; // стиль вынеси сюда

const Navigation = () => {
  const user = useSelector(selectUser);
  const email = useSelector(selectUserEmail)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authUser');
    dispatch(setUser(null));
    navigate('/auth');
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="top-nav">
      <div className="nav-left">
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <div className="nav-center">
        <Link to="/myslots" className={`nav-link ${isActive('/myslots')}`}>Мои слоты</Link>
        <Link to="/slots" className={`nav-link ${isActive('/slots')}`}>Все слоты</Link>
      </div>
      <div className="nav-right" ref={dropdownRef}>
        <div className="nav-user" onClick={() => setDropdownOpen(!dropdownOpen)}>
          <span className="nav-link">{user?.name}<span className="arrow">▼</span></span>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <Link to="/profile" className="dropdown-item">Профиль</Link>
              <div className="dropdown-item" onClick={handleLogout}>Выйти</div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
